// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: qUVFukdm6B2T
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import Sidebar from "../../Sidebar"; // plasmic-import: NdFBK2CrJIH5/component
import TopBar from "../../TopBar"; // plasmic-import: 0Oim0KTDv11d/component
import ClientsListCard from "../../ClientsListCard"; // plasmic-import: 74swX8o1_CEp/component
import { useScreenVariants as useScreenVariantseuyRl26Gw8Ft } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EuyRl26Gw8Ft/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDebtorsList.module.css"; // plasmic-import: qUVFukdm6B2T/css

createPlasmicElementProxy;

export const PlasmicDebtorsList__VariantProps = new Array();

export const PlasmicDebtorsList__ArgProps = new Array();

const $$ = {};

function PlasmicDebtorsList__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantseuyRl26Gw8Ft()
  });
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          plasmic_antd_5_hostless_css.plasmic_tokens,
          sty.root
        )}
      >
        <Sidebar
          data-plasmic-name={"sidebar"}
          data-plasmic-override={overrides.sidebar}
          className={classNames("__wab_instance", sty.sidebar)}
        />

        <div className={classNames(projectcss.all, sty.freeBox___6OAU)}>
          <TopBar
            data-plasmic-name={"topBar"}
            data-plasmic-override={overrides.topBar}
            className={classNames("__wab_instance", sty.topBar)}
          />

          <div
            data-plasmic-name={"uploadingDebtors"}
            data-plasmic-override={overrides.uploadingDebtors}
            className={classNames(projectcss.all, sty.uploadingDebtors)}
          >
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__yFyo9)}
            >
              <div
                data-plasmic-name={"title"}
                data-plasmic-override={overrides.title}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.title
                )}
              >
                {hasVariant(globalVariants, "screen", "large")
                  ? "Debtors"
                  : "Debtors"}
              </div>
              <Stack__
                as={"button"}
                data-plasmic-name={"addDebtorsButton2"}
                data-plasmic-override={overrides.addDebtorsButton2}
                hasGap={true}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.addDebtorsButton2
                )}
                ref={ref => {
                  $refs["addDebtorsButton2"] = ref;
                }}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zZbDf
                  )}
                >
                  {"\u24d8"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__vgVp
                  )}
                >
                  {"Requires Action"}
                </div>
              </Stack__>
              <Stack__
                as={"button"}
                data-plasmic-name={"addDebtorsButton"}
                data-plasmic-override={overrides.addDebtorsButton}
                hasGap={true}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  sty.addDebtorsButton
                )}
                ref={ref => {
                  $refs["addDebtorsButton"] = ref;
                }}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__jq1UK
                  )}
                >
                  {"+"}
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__j3Av
                  )}
                >
                  {hasVariant(globalVariants, "screen", "large")
                    ? "Add Debtors"
                    : "Add Debtors"}
                </div>
              </Stack__>
              <div
                data-plasmic-name={"searchVertStack"}
                data-plasmic-override={overrides.searchVertStack}
                className={classNames(projectcss.all, sty.searchVertStack)}
              />
            </Stack__>
          </div>
          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <Stack__
              as={"div"}
              data-plasmic-name={"figmaPaste2"}
              data-plasmic-override={overrides.figmaPaste2}
              hasGap={true}
              className={classNames(projectcss.all, sty.figmaPaste2)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lxfZm
                )}
              >
                {"Name"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__n9Qrn
                )}
              >
                {hasVariant(globalVariants, "screen", "large")
                  ? "Contact"
                  : "Contact"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ahIgj
                )}
              >
                {"Created"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__f8SFi
                )}
              >
                {hasVariant(globalVariants, "screen", "large")
                  ? "Status"
                  : "Status"}
              </div>
            </Stack__>
            <Stack__
              as={"div"}
              data-plasmic-name={"clientsListStack"}
              data-plasmic-override={overrides.clientsListStack}
              hasGap={true}
              className={classNames(projectcss.all, sty.clientsListStack)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__xXdYp)}>
                <ClientsListCard
                  className={classNames(
                    "__wab_instance",
                    sty.clientsListCard___2H3Oa
                  )}
                  clientName={"Family Vineyard Collectives"}
                  status={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__ytanh
                      )}
                    >
                      {"Needs Documentation"}
                    </div>
                  }
                />
              </div>
              <ClientsListCard
                className={classNames(
                  "__wab_instance",
                  sty.clientsListCard___6W4Db
                )}
                clientName={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__wcEBv
                    )}
                  >
                    {"Nike"}
                  </div>
                }
                date={"Dec 28th, 12:25 AM"}
                status={
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___32GHy
                    )}
                  >
                    {"Needs Documentation"}
                  </div>
                }
              />
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox__rDmnn)} />
            <div
              data-plasmic-name={"paginationStack"}
              data-plasmic-override={overrides.paginationStack}
              className={classNames(projectcss.all, sty.paginationStack)}
            >
              <div
                data-plasmic-name={"prevButton"}
                data-plasmic-override={overrides.prevButton}
                className={classNames(projectcss.all, sty.prevButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__jIsq3
                  )}
                >
                  {"Previous"}
                </div>
              </div>
              <div
                data-plasmic-name={"nextButton"}
                data-plasmic-override={overrides.nextButton}
                className={classNames(projectcss.all, sty.nextButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__wj4HZ
                  )}
                >
                  {"Next"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "topBar",
    "uploadingDebtors",
    "title",
    "addDebtorsButton2",
    "addDebtorsButton",
    "searchVertStack",
    "vertStack",
    "figmaPaste2",
    "clientsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  sidebar: ["sidebar"],
  topBar: ["topBar"],
  uploadingDebtors: [
    "uploadingDebtors",
    "title",
    "addDebtorsButton2",
    "addDebtorsButton",
    "searchVertStack"
  ],

  title: ["title"],
  addDebtorsButton2: ["addDebtorsButton2"],
  addDebtorsButton: ["addDebtorsButton"],
  searchVertStack: ["searchVertStack"],
  vertStack: [
    "vertStack",
    "figmaPaste2",
    "clientsListStack",
    "paginationStack",
    "prevButton",
    "nextButton"
  ],

  figmaPaste2: ["figmaPaste2"],
  clientsListStack: ["clientsListStack"],
  paginationStack: ["paginationStack", "prevButton", "nextButton"],
  prevButton: ["prevButton"],
  nextButton: ["nextButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDebtorsList__ArgProps,
          internalVariantPropNames: PlasmicDebtorsList__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDebtorsList__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDebtorsList";
  } else {
    func.displayName = `PlasmicDebtorsList.${nodeName}`;
  }
  return func;
}

export const PlasmicDebtorsList = Object.assign(
  // Top-level PlasmicDebtorsList renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    topBar: makeNodeComponent("topBar"),
    uploadingDebtors: makeNodeComponent("uploadingDebtors"),
    title: makeNodeComponent("title"),
    addDebtorsButton2: makeNodeComponent("addDebtorsButton2"),
    addDebtorsButton: makeNodeComponent("addDebtorsButton"),
    searchVertStack: makeNodeComponent("searchVertStack"),
    vertStack: makeNodeComponent("vertStack"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    clientsListStack: makeNodeComponent("clientsListStack"),
    paginationStack: makeNodeComponent("paginationStack"),
    prevButton: makeNodeComponent("prevButton"),
    nextButton: makeNodeComponent("nextButton"),
    // Metadata about props expected for PlasmicDebtorsList
    internalVariantProps: PlasmicDebtorsList__VariantProps,
    internalArgProps: PlasmicDebtorsList__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDebtorsList;
/* prettier-ignore-end */
